/**
 * Copyright © 2024 Delicious AI, LLC
 */

export const delay = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}
